import type { SVGProps } from "react";

export default function SolarBoxMinimalisticLinear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth={1.5}>
        <path d="M15.578 3.382L17.578 4.432c2.151 1.129 3.227 1.693 3.825 2.708C22 8.154 22 9.417 22 11.942v.116c0 2.525 0 3.788-.597 4.802c-.598 1.015-1.674 1.58-3.825 2.709l-2 1.049C13.822 21.539 12.944 22 12 22s-1.822-.46-3.578-1.382l-2-1.05c-2.151-1.129-3.227-1.693-3.825-2.708C2 15.846 2 14.583 2 12.058v-.116c0-2.525 0-3.788.597-4.802c.598-1.015 1.674-1.58 3.825-2.708l2-1.05C10.178 2.461 11.056 2 12 2s1.822.46 3.578 1.382Z" />
        <path d="M21 7.5L12 12M12 12L3 7.5M12 12v9.5" />
      </g>
    </svg>
  );
}
